// @flow
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import withEscapeToDismiss from 'components/others/WithEscapeToDismiss';
import './CohortLocationModal.scss';

type Props = {
  cohortID: string,
  cohortSetLocation: Function,

  handleClose: Function,
  showModal: boolean,
  onAutoCompleteLocation: Function,
  autoCompleteLocations: Array<any>,
};

const LocationSuggestions = ({ locations, clickHandler }) => (
  <nav className={classnames('panel', {
    'is-hidden': _.size(locations) === 0,
  })}
  >
    <div className="panel-block">
      <aside className="menu">
        <ul className="menu-list">
          {_.map(locations, (loc, idx) => (
            <LocationSuggestion text={loc} clickHandler={clickHandler} key={idx} />
          ))}
        </ul>
      </aside>
    </div>
  </nav>
);

LocationSuggestions.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.string).isRequired,
  clickHandler: PropTypes.func.isRequired,
};

const LocationSuggestion = ({ text, clickHandler }) => (
  <li><a onClick={clickHandler}>{text}</a></li>
);

LocationSuggestion.propTypes = {
  text: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
};

@withEscapeToDismiss()
export default class CohortLocationModal extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeLocation: null,
      autocompleteLocations: null,
      activeLocationName: '',
      selectedLocation: false,
    };
  }

  componentWillUpdate(nextProps: Props) {
    const autocompleteLocationsChanged: boolean = this.props.autoCompleteLocations !== nextProps.autoCompleteLocations;

    if (autocompleteLocationsChanged) {
      const storedLocations = _.reduce(nextProps.autoCompleteLocations, (acc, loc) => ({
        ...acc,
        [loc.place_name]: _.join(_.reverse(loc.center), ','),
      }), {});
      this.setState({
        autocompleteLocations: storedLocations,
      });
    }
  }

  setLocation = (event: Object) => {
    if (event.target.innerText in this.state.autocompleteLocations) {
      this.setState({
        activeLocation: this.state.autocompleteLocations[event.target.innerText],
        activeLocationName: event.target.innerText,
        selectedLocation: true,
      });
    }
  };

  render() {
    const address = this.locationInput ? this.locationInput.value : '';
    return (
      <div
        className={classnames('modal', {
          'is-active': this.props.showModal,
        })}
        role="dialog"
      >
        <div
          className="modal-background" onClick={() => {
            this.props.handleClose();
          }}
        />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Location Suggestions</p>
            <button
              aria-label="Close modal"
              className="delete"
              onClick={() => {
                this.props.handleClose();
              }}
            />
          </header>
          <section className="modal-card-body">
            <div className="field">
              <p className="control">
                <label className="label sr-only" htmlFor="address">Search address here</label>
                <input
                  id="address"
                  className="input"
                  type="text"
                  placeholder="Search address"
                  autoComplete="off"
                  onKeyUp={(event: Object) => {
                    if (event.target.value.length !== 0) {
                      this.setState({
                        selectedLocation: false,
                      });
                    }
                    if (event.target.value.length <= 2) {
                      this.setState({
                        autocompleteLocations: {},
                      });
                    }
                    if (event.target.value.length > 2) {
                      this.props.onAutoCompleteLocation(event.target.value);
                    }
                  }}
                  onChange={(event: Object) => {
                    this.setState({
                      activeLocationName: event.target.value,
                    });
                  }}
                  ref={(locationInput) => { this.locationInput = locationInput; }}
                  value={this.state.activeLocationName}
                />
              </p>
              {!this.state.selectedLocation &&
                <LocationSuggestions
                  clickHandler={this.setLocation}
                  locations={Object.keys(this.state.autocompleteLocations || {})}
                />}
            </div>
          </section>
          <footer className="modal-card-foot">
            <button
              className="button"
              onClick={() => {
                this.props.handleClose();
              }}
            >
              Cancel
            </button>
            <button
              className="button is-primary"
              aria-label={`Set cohort to address: ${address}`}
              onClick={() => {
                this.props.cohortSetLocation(this.state.activeLocation);
                this.props.handleClose();
              }}
            >
              Set Location
            </button>
          </footer>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/others/CohortLocationModal.js
 **/